/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RespuestaEncuestaModelDto } from '../../models/respuesta-encuesta-model-dto';

export interface EncuestasControllerEnviarEncuestaPaciente$Params {

/**
 * UUID de la encuesta del paciente
 */
  uuidEncuesta: string;
  
    /**
     * Detalles de la encuesta del paciente
     */
    body: Array<RespuestaEncuestaModelDto>
}

export function encuestasControllerEnviarEncuestaPaciente(http: HttpClient, rootUrl: string, params: EncuestasControllerEnviarEncuestaPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, encuestasControllerEnviarEncuestaPaciente.PATH, 'post');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

encuestasControllerEnviarEncuestaPaciente.PATH = '/api/paciente-encuestas/enviar-encuesta-paciente/{uuidEncuesta}';
